<template>
  <c-data-filters>
    <template #basic>
      <label class="sr-only">Search</label>

      <c-input type="text" :value="filters.search" @input="updateSearch">
        <i slot="prepend" class="fal fa-search" />
      </c-input>
    </template>

    <div class="row">
      <div class="col-12 col-lg-4 col-xl-9">
        <div class="mb-3">
          <label>Search</label>

          <c-input type="text" :value="filters.search" @input="updateSearch">
            <i slot="prepend" class="fal fa-search" />
          </c-input>
        </div>
      </div>
      <div class="col-12 col-lg-4 col-xl-3">
        <div class="mb-3">
          <label>Sort By</label>

          <c-input
            as="multiselect"
            placeholder
            :options="sortByOptions"
            :searchable="false"
            :preselect-first="true"
            :show-labels="false"
            :allow-empty="false"
            label="name"
            v-model="sortBy"
          >
            <i slot="prepend" class="fal fa-sort-amount-down" />
          </c-input>
        </div>
      </div>
      <div class="col-12">
      </div>
    </div>
  </c-data-filters>
</template>

<script>
import { useQueryParamFilters } from '@codium/codium-vue'
import { debounce } from 'lodash'

export default {
  mixins: [useQueryParamFilters()],

  data () {
    return {
      filters: {
        search: null,
        sort: 'name,asc'
      },
      sortByOptions: [
        { name: 'Newest First', key: 'created', order: 'desc' },
        { name: 'Oldest First', key: 'created', order: 'asc' },
        { name: 'A-Z', key: 'name', order: 'asc' },
        { name: 'SLA Type', key: 'type', order: 'asc' }
      ],
    }
  },

  computed: {
    status: {
      get () {
        return this.statusOptions.find(({ value }) => value === this.filters.status)
      },

      set ({ value }) {
        this.filters.status = value
      }
    },

    sortBy: {
      get () {
        const { filters, sortByOptions } = this

        return sortByOptions.find(({ order, key }) => filters.sort === `${key},${order}`)
      },

      set ({ key, order }) {
        this.filters.sort = `${key},${order}`
      }
    },

    updateSearch () {
      return debounce((value) => {
        this.filters.search = value
      }, 1000)
    }
  },

  watch: {
    queryParams: {
      handler (params) {
        this.$emit('input', params)
      },
      immediate: true
    }
  }
}
</script>
